import styled from "styled-components";

export const AboutUsContainer = styled.div`
  background-color: var(--homeBG);
  padding: 4rem 4rem;
  display: flex;
  /* align-items: center; */
  justify-content: center;
  flex-direction: column;
  gap: 4rem;
  @media (max-width: 500px) {
    padding: 4rem 2rem;
  }
  h1 {
    color: var(--blue);
    font-weight: 500;
    font-size: 2.2rem;
  }
  p {
    font-size: 1.5rem;
    color: var(--textGrey);
  }
  h2 {
    text-align: center;
    font-size: 2.2rem;
    font-weight: 400;
    color: var(--textGrey);
  }
`;
